/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'ONLY_AUTHORIZED_PEOPLE_VEHICLES_ARE_ALLOWED_TO_DRIVE_ON_SITE',
              'VEHICLES_ARE_DRIVEN_AT_AN_APPROPRIATE_SPEED',
              'TRAFFIC_LANES_AND_WALK_PATHS_ARE_CLEARLY_MARKED',
              'VEHICLES_ARE_IN_GOOD_WORKING_CONDITION',
              'ONLY_AUTHORIZED_TRAINED_AND_QUALIFIED_PEOPLE_DRIVE_VEHICLES',
              'VEHICLES_ARE_USED_FOR_PURPOSES_FOR_WHICH_THEY_ARE_INTENDED_AND_',
              'FACILITY_PROVIDES_VISUAL_MANAGEMENT_SUCH_AS_INDICATORS_CONVEX_M',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_safety_measures_in_place_regarding_onsite_veh: valueSchema,
  },
}
